import { ADD_PROJECT, DELETE_PROJECT, SET_CURRENT, CLEAR_CURRENT, UPDATE_PROJECT, FILTER_PROJECTS, CLEAR_FILTER, PROJECT_ERROR, GET_PROJECTS, CLEAR_PROJECTS } from '../types';

// import/no-anonymous-default-export
export default (state, action) => {
  switch (action.type) {
    case GET_PROJECTS:
      return {
        ...state,
        projects: action.payload,
        loading: false
      };
    case ADD_PROJECT:
      return {
        ...state,
        projects: [action.payload, ...state.projects],
        loading: false
      };
    case DELETE_PROJECT:
      return {
        ...state,
        projects: state.projects.filter(project => project._id !== action.payload),
        loading: false
      };
    case UPDATE_PROJECT:
      return {
        ...state,
        projects: state.projects.map(project => project._id === action.payload.id ? action.payload : project),
        loading: false
      };
    case CLEAR_PROJECTS:
      return {
        ...state,
        projects: null,
        filtered: null,
        error: null,
        current: null
      };
    case SET_CURRENT:
      return {
        ...state,
        current: action.payload
      };
    case CLEAR_CURRENT:
      return {
        ...state,
        current: null
      };
    case FILTER_PROJECTS:
      return {
        ...state,
        filtered: state.projects.filter(project => {
          const regex = new RegExp(`${action.payload}`, 'gi');
          return project.name.match(regex)  || project.email.match(regex);
        })
      };
    case CLEAR_FILTER:
      return {
        ...state,
        filtered: null
      };
    case PROJECT_ERROR:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
}